import React from 'react';
import { Link, useNavigate, useOutletContext } from 'react-router-dom';
import { formatDay } from '../../../lib/assets';
import { FINISHED } from '../assetView';

/**
 * TICKETS: every ticket that was ever about this device, the open ones
 * first, and Report a problem at the top so the next one starts here.
 */
export default function TicketsTab() {
  const { data, asset, gone, meta, portal } = useOutletContext();
  const navigate = useNavigate();
  const tickets = data.tickets || [];
  const isOpen = (t) => !FINISHED.includes(String(t.status || '').toLowerCase());
  const open = tickets.filter(isOpen);
  const closed = tickets.filter((t) => !isOpen(t));
  const ticketPath = (t) => (portal ? `/my-tickets/${t.id}` : `/tickets/${t.id}`);
  const Row = ({ t }) => (
    <li key={t.id} data-ticket={t.id}>
      <Link to={ticketPath(t)}>{t.ticket_number}</Link>{` — ${t.title}`}
      <span className="as-when">
        {[t.status, t.requester_name ? `raised by ${t.requester_name}` : null,
          t.contractor_name ? `fixed by ${t.contractor_name}` : null,
          formatDay(t.created_at)].filter(Boolean).join(' · ')}
      </span>
    </li>
  );
  return (
    <div className="as-tab as-tab-tickets">
      {!gone && meta?.enabled && (
        <div className="as-actions" style={{ margin: '0 0 0.9rem' }}>
          <button type="button" className="btn btn-primary" onClick={() => navigate(`/create?asset=${asset.id}`)}>
            Report a problem
          </button>
        </div>
      )}
      {tickets.length === 0 && (
        <section className="as-panel"><p className="as-empty">No ticket has been about this device.</p></section>
      )}
      {open.length > 0 && (
        <section className="as-panel">
          <h2>{`Open (${open.length})`}</h2>
          <ul className="as-history">{open.map((t) => <Row key={t.id} t={t} />)}</ul>
        </section>
      )}
      {closed.length > 0 && (
        <section className="as-panel">
          <h2>{`Closed (${closed.length})`}</h2>
          <ul className="as-history">{closed.map((t) => <Row key={t.id} t={t} />)}</ul>
        </section>
      )}
    </div>
  );
}
